export default function AOEmbed() {
  const WIDGET_EVENT_ATTRIBUTE = 'data-b2b-widget-event';
  const WIDGET_EVENT_CUSTOM_ATTRIBUTE = 'data-b2b-widget-attr-';
  const BODY_CLASS_NAME = 'ao-embed-body';

  const getBodyCSS = () => {
    const styles = [
      'height: auto !important',
      'width: 100% !important',
      'display: inline-block !important',
    ];
    if (window.location.href.includes('transparent=true')) {
      styles.push('background: transparent !important');
    }
    return styles.map((style) => `${style};`).join('\n').trim();
  };

  const fixDocument = () => {
    const style = document.createElement('style');
    document.head.appendChild(style);
    style.sheet.insertRule(`
        html > body.${BODY_CLASS_NAME} {
            ${getBodyCSS()}
         }
    `);
    document.body.classList.add(BODY_CLASS_NAME);
  };

  const getCustomAttributes = ($widget) => {
    const customAttributes = {};
    if (!$widget.length) {
      return customAttributes;
    }
    /** @type {HTMLElement} */
    const element = $widget[0];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < element.attributes.length; i++) {
      const attrib = element.attributes[i];
      if (attrib.name.startsWith(WIDGET_EVENT_CUSTOM_ATTRIBUTE)) {
        const attr = attrib.name.replace(WIDGET_EVENT_CUSTOM_ATTRIBUTE, '');
        customAttributes[attr] = attrib.value;
      }
    }

    return customAttributes;
  };

  const sendEvent = (event, data) => {
    window.parent.postMessage({
      source: 'b2b-tourradar',
      event,
      windowName: window.name,
      data,
    }, '*');
  };

  const refreshSize = () => {
    const { body } = document;

    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
    ) + 5;

    const width = Math.max(
      body.scrollWidth,
      body.offsetWidth,
    );

    sendEvent('resize', { height, width });
  };

  const interactionBind = (events) => {
    const clicks = events?.click;

    $('body').on('click', `[${WIDGET_EVENT_ATTRIBUTE}]`, (event) => {
      const $widget = $(event.target);
      const selector = $widget.attr(WIDGET_EVENT_ATTRIBUTE);
      if (!clicks.includes(selector)) {
        return true;
      }

      const attributes = getCustomAttributes($widget);
      sendEvent('interaction', {
        type: 'click',
        selector,
        attributes,
      });

      return false;
    });
  };

  const initialiseResize = () => {
    const elements = [document.body, document.body.querySelector('main')];
    elements.forEach((element) => {
      if (!element) {
        return;
      }

      const observer = new ResizeObserver(() => {
        window.requestAnimationFrame(() => refreshSize());
      });
      observer.observe(element);
    });
  };

  const initiateListener = () => {
    window.addEventListener(
      'message',
      (event) => {
        if (event.data?.source !== 'b2b-tourradar') {
          return;
        }
        if (event.data.event === 'interaction-bind') {
          interactionBind(event.data.events);
        }
      },
      false,
    );
  };

  const initiate = () => {
    if (!window.parent) {
      return;
    }

    fixDocument();
    initiateListener();
    initialiseResize();
  };

  return { initiate };
}
